<h2 class="mat-h2">Users</h2>
<mat-table [dataSource]="licenceOwners$ | async">
  <ng-container matColumnDef="email">
    <mat-header-cell *matHeaderCellDef> email</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.email }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="displayName">
    <mat-header-cell *matHeaderCellDef> displayName</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.displayName }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="role">
    <mat-header-cell *matHeaderCellDef> role</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.role }}</mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columns"></mat-row>
</mat-table>
